import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";
import { useForm } from "react-hook-form";

const WithdrawModal = ({ close, step, setStep }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  return (
    <div className="relative">
      <button
        onClick={() => {
          close(false);
          setStep(0);
        }}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className="text-center text-[#77498F]">تسویه حساب</h3>
      <div className="text-center flex flex-col justify-center items-center mt-[8rem] mb-[16rem]">
        <p className="text-3xl mb-5">درخواست شما با موفقیت ثبت شد.</p>
        <p className="text-3xl">
          مبلغ 1,500,000 تومان به شماره شبا IR-0315-0000000000000-1235499 بانک
          ملی ایران واریز خواهد شد.
        </p>
      </div>

      <BtnPrimary
        className="py-[2rem] px-[10rem] flex mr-auto"
        text="تایید"
        onClick={() => {
          close(false);
          setStep(0);
        }}
      />
    </div>
  );
};

export default WithdrawModal;
